import { inject } from '@angular/core';
import { ResolveFn, UrlSegment } from '@angular/router';

import { ConfigService } from '@app/config.service';
import { EventService } from '@common/event.service';
import { IdentityClientService } from '@identity/identity-client.service';
import { IdentityConfigurationService } from '@identity/identity-configuration.service';
import { IdentityConstants } from '@identity/identity-constants.service';
import { SharedConstants } from '@shared/constants';

const MODULES: any = Object.freeze({
    'tpo': 'TP',
    'buildingcontrol': 'BR',
    'enforcements': 'EN',
    'reporting': 'REPORTING',
    'planning': 'PA',
    'preapps': 'PR',
    'built-environment': 'CPW',
    'publicprotection': 'PP',
    'landcharges': 'LC',
    'gisadminsite': 'GIS',
    'synchronizer': 'SYNC',
    'configurator': 'CONFIGURATOR',
    'hmlr': 'HMLR',
    'terraquest-integrator': 'TQI',
});

export const moduleResolver: ResolveFn<void> = async (route, state) => {
    const identityConfigService = inject(IdentityConfigurationService);
    const eventService = inject(EventService);
    const configService = inject(ConfigService);

    const moduleCode = getModuleCode(route.url);
    identityConfigService.setService(moduleCode);

    const client = new IdentityClientService(new IdentityConstants()).get();
    const clientUrl = client.url;
    await configService.getModuleConfig(clientUrl);
    eventService.emitEvent(SharedConstants.RELOAD_HEADER_EVENT, {})
    eventService.emitEvent(SharedConstants.RELOAD_MENU_EVENT, {})
};

function getModuleCode(segments: UrlSegment[]): string {
    const moduleCode = segments[0].path.toLowerCase();

    return MODULES[moduleCode] || 'HUB';
}
